export const ro = {
    idle1: 'Un lot extraordinar!',
    idle2: 'Acum este momentul să licitezi!',
    idle3: 'Nu rata această șansă!',
    idle4: 'Mai așteptăm câteva momente.',
    seconds: 'Au mai rămas {value} secunde pentru a licita.',
    fairwarningclose: 'Ultima șansă!',
    error: 'Am întâmpinat o problemă. Te rog să reîncerci în câteva momente.',
    bids: {
        current: 'Preț curent',
        ask: 'Preț cerut',
        bid: 'Licitează',
        bid_warn: 'ULTIMA ȘANSĂ! Licitează',
        highest: 'Pasul de {value} EUR este al tău!',
        sent: 'Ai oferit {value} EUR!',
        wait: 'Așteaptă licitarea lotului.',
        sold: 'Lot adjudecat!',
        congrats: 'Felicitări! Lotul este al tău.',
        pass: 'Următorul lot!',
        received: 'Oferta ta de {value} EUR a fost trimisă!',
        confirmation: 'Ești pe cale de a licita',
        confirmation_info: 'Ești sigur că vrei să licitezi pentru acest lot?',
        hold: 'Continuă să ții apăsat butonul...',
        outbid: 'Ai fost contralicitat!',
        more: 'sau mai mult',
        is_bidding: 'Transmitem oferta...',
    },
    account: {
        review: 'Revizuiește datele contului',
        login: 'Nu ești autentificat!',
        your_paddle: 'Paleta ta este',
        status_asteptare: 'În așteptare',
        aprobat: 'Cont aprobat',
        neaprobat: 'Cont neaprobat',
    },
    lots: {
        prev: 'Licitate',
        next: 'Următoare',
        no_results: 'Niciun rezultat pentru',
        no_more_lots: 'Niciun lot rămas de vizualizat',
        sold: 'Adjudecat',
        pass: 'Neadjudecat',
        withdrawn: 'Retras',
        sold_post: 'Vândut post-licitație',
        open: 'Licitarea a început',
        recalled: 'Lot reintrodus',
        support: 'Pentru suport contactați',
        search_lots: 'Caută loturi',
    },
    lot: {
        recall: 'Reintroducere',
        recalled: 'Solicitarea ta de reintroducere a fost transmisă conducatorului licitației',
        absentee: 'Ofertă în absență',
        absentee_sent: 'Oferta în absență a fost trimisă',
        reminder: 'Aminteşte-mi să licitez',
        details: 'Detalii',
        next: 'Urmează'
    },
    general: {
        lot: 'Lot',
        est: 'Est',
        sp: 'PP', //'Preț de pornire',
        close: 'Închide',
        deactivate: 'Dezactivează',
        cancel: 'Anulează',
        loading: 'Se încarcă',
        standby: 'Licitația va începe în curând. Te rugăm să aștepți!',
        break: 'Licitația va continua în scurt timp. Te rugăm să aștepți!',
        ended: 'Licitația s-a încheiat. Îți mulțumim pentru participare!',
        back_to_current: 'Înapoi la lotul curent al licitației',
        room_view: 'Extinde ecranul',
        standard_view: 'Restrânge ecranul',
        turn_on_sound: 'Pornește sunetul',
        turn_off_sound: 'Închide sunetul',
        mute_video: 'Oprește sunetul transmisiei video',
        unmute_video: 'Pornește sunetul transmisiei video',
        mute_sounds: 'Oprește alertele audio',
        unmute_sounds: 'Pornește alertele audio',
        redirect_home: 'Vei fi redirecționat către pagina de pornire în {seconds} secunde...',
        redirect_old: 'Vei fi redirecționat către Platforma de licitare Artmark Live în {seconds} secunde...',
        redirect_now: 'Redirecționează-mă acum!',
        reload_all: 'Aplicația se va reîncărca în {seconds} secunde...',
        reload_now: 'Reîncarcă acum!',
        welcome: 'Bine ați venit pe platforma de licitații Artmark Live! Licitatia începe în curand, conform cronometrului. Vă invităm să parcurgeți cu atenție <a href="/ro/reguli-licitatie" target="_blank" class="underline">Regulamentul de Licitare</a>, înainte de a participa. Ne puteți contacta la <a href="mailto:office@artmark.ro" class="underline">office@artmark.ro</a> pentru nelămuriri în legătura cu regulile de licitație ori la <a href="mailto:auctions@artmark.ro" class="underline">auctions@artmark.ro</a> pentru consultanță cu privire la loturile licitației. Succes!',
        ok: 'Ok',
        contact_1: '<a href="tel:+40 736 381 178" class="underline">+40 736 381 178</a>',
        contact_2: '<a href="tel:+40 758 056 113" class="underline">+40 758 056 113</a>',
    },
    modals: {
        send_offer: 'Lasă o ofertă',
        send_offer_details: 'Alege suma maximă pe care dorești să o oferi. Vom licita in numele tău până la această sumă, fără să o depășim.',
        send_absentee_bid: 'Plasează o ofertă în absență',
        maximum_amount: 'Suma maximă oferită',
        bid_more: 'Oferă direct un preț mai mare',
        bid_more_details: 'Ești sigur că dorești să oferi direct prețul de',
        bid_more_confirmation: 'Oferă prețul',
        recall_title: 'Rechemare în licitație',
        recall_details: 'Ești sigur că vrei să rechemi în licitație lotul {lot}, {description}? Vom plasa în mod automat o ofertă în numele tău pentru',
        recall_reserve: 'prețul de rezervă de',
        recall_starting_prince: 'prețul de pornire de',
        recall_continue: 'Dorești să continui?',
    },
    messages: {
        lot_announce: 'Lotul {lot}',
        lot_open: 'A început licitarea! Oferă acum pasul de {ask} EUR!',
        lot_open_winner: 'Paleta {paddle} are prețul curent de {curent}',
        lot_reserve: 'Pasul de {value} EUR este al tău!',
        lot_sell_congrats: 'Felicitări! Lotul este al tău.',
        lot_sell: 'Lot adjudecat!',
        lot_pass: 'Următorul lot',
        lot_pass_reserve: 'Prețul de rezervă nu a fost atins. Următorul lot',
        lot_reset: 'Lotul {lot}',
        bid_win_congrats: 'Pasul de {value} EUR este al tău!',
        bid_win: '{paddle} a castigat pasul de {ask} EUR',
        bid_outbid: 'Ai fost contralicitat!',
        price_changed: 'Prețul curent al lotului este de {price} EUR',
        ask_changed: 'Pretul cerut este de {ask} EUR',
        bid_receive: '{paddle} a oferit {ask} EUR',
        lot_warn: 'De trei ori - Atenție, ultima șansă...',
        lot_warn_fairwarningclose: 'De trei ori - Atenție, ultima șansă...',
        lot_warn_once: 'O dată...',
        lot_warn_twice: 'De două ori...',
        lot_warn_seconds: 'Au mai rămas {seconds} secunde...',
        // lot_recall: 'A fost cerută reintroducerea lotului {lot}',
        lot_recall: 'Paleta {paddle} reintroduce lot {lot}'
    },
    timer: {
        days: 'zile',
        hours: 'ore',
        minutes: 'minute',
        seconds: 'secunde',
    }
}
